import React from "react";
import View from "components/View";
import * as styles from "styles";

const Row = props => <View {...styles.row} {...props} />;

export default Row;
